import Splide from '@splidejs/splide';

export default class Slider {
  constructor() {
    // フリック設定
    this.threshold    = 30;    // px
    this.timeLimit    = 500;   // ms
    this.startX       = 0;
    this.startT       = 0;
    this.kvSplide     = null;
    this.museumSplide = null;
    this.lineupSplide = null;
    this.tnSlide      = null;

    this.init();
  }

  init() {
    // — KVスライダー + サムネイル —
    const kvEl = document.querySelector('.js-splide');
    const tnEl = document.querySelector('.js-tb-slide');

    if (kvEl && tnEl) {
      this.kvSplide = new Splide(kvEl, {
        type        : 'slide',
        perPage     : 1,
        autoplay    : true,
        arrows      : false,
        pagination  : true,
        interval    : 8000,
        pauseOnHover: false,
        speed       : 0,
        drag        : false,
        rewind      : true,
        breakpoints : {
          768: {pagination: false}
        }
      })
      .on('mounted', () => this.bindFlickHandlers())
      .on('inactive', Slide => {
        const slideEl = Slide.slide;
        slideEl.classList.add('is-transition');
      })
      .on('moved', () => {
        this.kvSplide.Components.Elements.slides.forEach(slide => {
          slide.classList.remove('is-transition');
        });
      });

      this.tnSlide = new Splide(tnEl, {
        gap         : 15,
        autoplay    : true,
        arrows      : true,
        pagination  : false,
        rewind      : true,
        isNavigation: true,
        perPage     : 3,
        breakpoints : {
          769: { perPage: 2, gap: 10 },
        },
      });

      this.kvSplide.sync(this.tnSlide);
      this.kvSplide.mount();
      this.tnSlide.mount();


      // スライドが3枚のとき
      const checkThreeSlides = () => {
        const isThreeSlides = this.kvSplide.Components.Elements.slides.length === 3;
        if (isThreeSlides) {
          tnEl.classList.add('three-slides');
          this.tnSlide.options = {
            ...this.tnSlide.options,
            perPage: 3,
            gap: 10,
            breakpoints: {
              769: {
                perPage: 3,
                gap: 10,
              },
            },
          };
        } else {
          tnEl.classList.remove('three-slides');
        }
      };

      const resizeHandler = () => {
        checkThreeSlides();
      };

      window.addEventListener('resize', resizeHandler);
      checkThreeSlides();

    }

    //レスポンシブ切り替えのJS
    const responsiveSliders = [
      { key: 'museum', className: '.js-museum-splide', gap: 15,speed: 3000,interval:3500 },
      { key: 'lineup', className: '.js-lineup-splide', gap: 10,speed: 2000,interval:3000 },
    ];

    responsiveSliders.forEach(({ key, className, gap,speed,interval }) => {
      const el = document.querySelector(className);
      if (el) {
        this.initResponsiveSlider(key, el, gap,speed,interval);
        window.addEventListener('resize', () => this.initResponsiveSlider(key, el, gap,speed,interval));
      }
    });

  }

  bindFlickHandlers() {
    const slides = this.kvSplide.root.querySelectorAll('.splide__slide');
    slides.forEach(slide => {
      slide.style.touchAction = 'none';
      slide.addEventListener('pointerdown', e => this.onDown(e));
      slide.addEventListener('pointerup',   e => this.onUp(e));
    });
  }

  onDown(e) {
    this.startX = e.clientX;
    this.startT = performance.now();
  }

  onUp(e) {
    const dx = e.clientX - this.startX;
    const dt = performance.now() - this.startT;
    if (dt < this.timeLimit && Math.abs(dx) > this.threshold) {
      dx < 0 ? this.kvSplide.go('>') : this.kvSplide.go('<');
      return;
    }
    const half = this.kvSplide.root.clientWidth / 2;
    if (dx < -half) this.kvSplide.go('>');
    if (dx >  half) this.kvSplide.go('<');
  }

  
  initResponsiveSlider(key, element, gap, speed,interval) {
    const breakpoint = 767;

    const instanceKey = `${key}Splide`;
    if (this[instanceKey]) {
      this[instanceKey].destroy(true);
      this[instanceKey] = null;
    }

    if (window.innerWidth <= breakpoint) {
      this[instanceKey] = new Splide(element, {
        type: 'loop',
        arrows: false,
        pagination: false,
        autoWidth: true,
        autoplay: true,
        perMove: 1,
        interval: interval,
        speed: speed,
        gap: gap,
      });

      this[instanceKey].on('dragged', () => {
        this[instanceKey].Components.Autoplay.play();
      });

      const bar = element.querySelector('.my-carousel-progress-bar');
      this[instanceKey].on('mounted move', () => {
        const end = this[instanceKey].Components.Controller.getEnd() + 1;
        const rate = Math.min((this[instanceKey].index + 1) / end, 1);
        if (bar) bar.style.width = `${rate * 100}%`;
      });

      this[instanceKey].mount();


      setTimeout(() => {
        const links = element.querySelectorAll('.splide__slide a');
        links.forEach(link => {
          let startX = 0, startY = 0;
          //タップが始まった位置を記録
          link.addEventListener('touchstart', e => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
          });
          //タップ終了位置から移動距離を計算 
          link.addEventListener('touchend', e => {
            const dx = Math.abs(e.changedTouches[0].clientX - startX);
            const dy = Math.abs(e.changedTouches[0].clientY - startY);
            // 10px未満 → スワイプではなくタップと判定
            if (dx < 10 && dy < 10) {
              e.preventDefault(); 
              link.click();
            }
          });
        });
      }, 300);
    }
  }

}
